(() => {
  const formId = 'HenvoConfigurationInquiry';
  const contextKeys = ['model', 'product', 'product_url', 'category', 'material', 'application', 'requirements', 'collection', 'source_url'];
  function context() {
    const params = new URLSearchParams(location.search);
    return JSON.stringify(contextKeys.map(key => params.get(key) || ''));
  }
  function safeProductURL(value) {
    try {
      const url = new URL(value);
      return ['https:', 'http:'].includes(url.protocol) ? url.href : '';
    } catch { return ''; }
  }
  function safeSourceURL(value) {
    try {
      const url = new URL(value);
      if (url.origin !== location.origin || !url.pathname.includes('/collections/')) return '';
      url.search = '';
      url.hash = '';
      return url.href;
    } catch { return ''; }
  }
  function prefill() {
    const form = document.getElementById('HenvoConfigurationInquiry');
    if (!form || form.dataset.inquiryReady) return;
    form.dataset.inquiryReady = 'true';
    if (form.querySelector('[data-inquiry-success]')) {
      const { henvoInquiryDraft, ...state } = history.state || {};
      try { history.replaceState(state, '', location.href); } catch {}
      if (location.hash === '#' + formId) form.focus({ preventScroll: true });
      return;
    }
    const params = new URLSearchParams(location.search);
    const fields = [...form.querySelectorAll('input:not([type="hidden"]),textarea,select')];
    const restore = () => {
      const draft = history.state?.henvoInquiryDraft;
      if (!draft || draft.context !== context()) return;
      for (const input of fields) {
        const value = draft.values?.[input.name];
        if (typeof value !== 'string') continue;
        input.value = input.hasAttribute('data-inquiry-url') ? safeProductURL(value) : input.hasAttribute('data-inquiry-source-url') ? safeSourceURL(value) : value;
      }
    };
    restore();
    for (const key of ['model', 'material', 'category']) {
      const input = form.querySelector('[data-inquiry-' + key + ']');
      const value = params.get(key) || (key === 'model' ? params.get('product') : '');
      if (input && !input.value && value && value.trim() !== 'Default Title') input.value = value.slice(0, 512);
    }
    const collectionInput = form.querySelector('[data-inquiry-collection]');
    const sourceInput = form.querySelector('[data-inquiry-source-url]');
    const sourceURL = safeSourceURL(params.get('source_url'));
    if (collectionInput) collectionInput.value = sourceURL ? (params.get('collection') || '').slice(0, 512) : '';
    if (sourceInput) sourceInput.value = sourceURL;
    for (const input of [collectionInput, sourceInput]) {
      if (input) input.closest('[data-inquiry-context-field]').hidden = !input.value;
    }
    const application = params.get('application');
    const requirements = params.get('requirements');
    const body = form.querySelector('textarea[name="contact[body]"]');
    const applicationNames = ["Industrial Pump Applications","Corrosive Chemical Transfer","High-Viscosity Liquid Transfer","Industrial Vacuum Applications"];
    if (body && !body.value && applicationNames.includes(application) && requirements && requirements.includes('Application: ' + application)) body.value = requirements.slice(0, 4000);
    const input = form.querySelector('[data-inquiry-url]');
    const value = params.get('product_url');
    if (input && !input.value && value) {
      input.value = safeProductURL(value);
    }
    const syncProductContext = () => {
      const summary = form.querySelector('[data-inquiry-context]');
      if (!summary) return;
      let populated = false;
      for (const key of ['category', 'model', 'url']) {
        const input = form.querySelector('[data-inquiry-' + key + ']');
        const output = summary.querySelector('[data-inquiry-context-' + key + ']');
        if (!output) continue;
        const value = input?.value?.trim() || '';
        output.textContent = value;
        output.closest('[data-inquiry-context-row]').hidden = !value;
        if (value) populated = true;
      }
      summary.hidden = !populated;
    };
    syncProductContext();
    const save = () => {
      const values = Object.fromEntries(fields.map(input => [input.name, input.value]));
      try { history.replaceState({ ...history.state, henvoInquiryDraft: { context: context(), values } }, '', location.href); } catch {}
    };
    const locate = () => {
      form.focus({ preventScroll: true });
      const target = form.closest('.henvo-rfq-form') || form;
      const headerHeight = document.getElementById('header-component')?.getBoundingClientRect().height || 0;
      const targetTop = window.scrollY + target.getBoundingClientRect().top - headerHeight - 20;
      window.scrollTo({ top: Math.max(0, targetTop), behavior: 'instant' });
    };
    form.addEventListener('input', () => { syncProductContext(); save(); });
    form.addEventListener('change', () => { syncProductContext(); save(); });
    window.addEventListener('pagehide', save);
    window.addEventListener('pageshow', () => { restore(); syncProductContext(); });
    document.addEventListener('click', event => {
      if (event.defaultPrevented || event.button !== 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
      const anchor = event.target.closest('a[href]');
      if (!anchor || anchor.target === '_blank' || anchor.hasAttribute('download')) return;
      const target = new URL(anchor.href, location.href);
      if (target.origin !== location.origin || target.pathname !== location.pathname || target.hash !== '#' + formId) return;
      if (contextKeys.some(key => target.searchParams.has(key) && target.searchParams.get(key) !== params.get(key))) return;
      event.preventDefault();
      save();
      const address = new URL(location.href);
      address.hash = formId;
      history.replaceState(history.state, '', address.href);
      locate();
    });
    if (location.hash === '#' + formId) {
      requestAnimationFrame(locate);
      if (document.readyState !== 'complete') window.addEventListener('load', () => requestAnimationFrame(locate), { once: true });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', prefill);
  else prefill();
  document.addEventListener('shopify:section:load', prefill);
})();
